module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Abbreviations")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "abbreviations"
    }
  }, [_c('p', {
    staticClass: "chap-ttl"
  }, [_c('a', {
    attrs: {
      "id": "pix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Table_of_contents"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Only abbreviations not currently found in the "), _c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("SBL Handbook of Style")]), _vm._v(" are included here.")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("BMW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Bible in the Modern World")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("CTHP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Cambridge Texts in the History of Philosophy")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("DOML")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Dumbarton Oaks Medieval Library")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("ER")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Evangelical Ressourcement")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("FCBS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Fortress Classics in Biblical Studies")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("GSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Geneva Series Commentary")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("HBISJW  ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("HBI Series on Jewish Women")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("HBM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Hebrew Bible Monographs")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("JSRC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Jerusalem Studies in Religion and Culture")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("LOLA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Library of Liberal Arts")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("NCE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Norton Critical Editions")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("OECS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Oxford Early Christian Studies")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("OTT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Old Testament Theology")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("PMLA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_c('span', {
    staticClass: "epub-italic-normal-normal"
  }, [_vm._v("Publications of the Modern Language Association of America")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("RSMRC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Routledge Studies in Medieval Religion and Culture")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("STI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Studies in Theological Interpretation")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("TatC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Texts @ Contexts")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("TSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Theology and the Sciences")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("WPL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "chap-bm-first"
  }, [_vm._v("Wordsworth Poetry Library")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659f625f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abbreviations.vue
// module id = 75
// module chunks = 0